import React, { useState, useEffect, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import renderPageSection from "utils/renderPageSection";

import { useScreenSize } from "hooks";

import { screenSizes, checkColumnMode } from "utils/helpers";

export default function LeftRight(props) {
	const { size } = useScreenSize();

	const [isColumn, setIsColumn] = useState(false);
	let { leftCol = { xs: 12, lg: 6 }, rightCol = { xs: 12, lg: 6 } } = props;

	// Memoize padding calculations to prevent unnecessary re-renders
	const paddingStyles = useMemo(() => ({
		top: props.topPadding || 0,
		bottom: props.bottomPadding || 0,
		topMobile: (props.topPadding || 0) / 2,
		bottomMobile: (props.bottomPadding || 0) / 2
	}), [props.topPadding, props.bottomPadding]);

	const leftBgColor = props.leftBgColor || "inherit";
	const rightBgColor = props.rightBgColor || "inherit";
	const isWideContainer = props.isWideContainer;


	// let isColumnMode = checkColumnMode(size, leftCol, rightCol, sizes);
	useEffect(() => {
		const isColumnMode = checkColumnMode(size, leftCol, rightCol, screenSizes);

		setIsColumn(isColumnMode);
	}, [size]);

	const leftSideVerticalAlign = props.leftSideVerticalAlign || "start";
	const rightSideVerticalAlign = props.rightSideVerticalAlign || "start";
	const columnReverse = props.columnReverse;

	return (
		<div className="outerWrapper d-flex h-100">
			<Container
				fluid
				className={`d-flex ${isWideContainer ? `wide-container-${isWideContainer}` : "container-lg g-0"}`}
			>
				<div className={`innerWrapper w-100 `}>
					<Row className={`justify-content-center align-items-center  g-0`}>
						{/* // Top Side, only on medium and down */}
						{props.topSide && (
							<Col className="d-block d-lg-none" xs={12}>
								{props.topSide}
							</Col>
						)}

						<Col className="d-flex h-100">
							<Row
								className={` ${
									//this will determine if the left
									//and right side are in a row or column
									//and always make the right side (img) above the left (reverse)
									isColumn && columnReverse
										? "flex-column"
										: isColumn
										? "flex-column-reverse"
										: props.reverse
										? "flex-row-reverse"
										: "flex-row"
								}   g-0 w-100 h-100 justify-content-end `}
							>
								{/* Left Side */}
								<Col
									className={`LR-left justify-content-center align-self-stretch align-items-${leftSideVerticalAlign} d-flex  ${
										isColumn ? "pb-3" : ""
									}`}
									{...leftCol}
								>
									<div className={`leftSide w-100 align-items-${leftSideVerticalAlign}`}>
										{/* Leftside */}
										{props.leftSide || <></>}
									</div>
								</Col>
								{/* Right Side */}
								<Col
									className={`LR-right justify-content-center align-self-stretch align-items-${rightSideVerticalAlign} d-flex ${
										isColumn ? "pb-3" : " "
									}`}
									{...rightCol}
								>
									<div className={`rightSide w-100 align-items-${rightSideVerticalAlign}`}>
										{/* Right side */}
										{props.rightSide || <></>}
									</div>
								</Col>
							</Row>
							{props.bottomCenter && (
								<Row className="g-0">
									<Col>
										<div className="bottomCenter">
											{props.bottomCenter.map((pageSection) => {
												return (
													<React.Fragment key={pageSection.sys.id}>
														{renderPageSection(pageSection)}
													</React.Fragment>
												);
											})}
										</div>
									</Col>
								</Row>
							)}
						</Col>
					</Row>
				</div>
			</Container>

			<style jsx>{`
				.outerWrapper {
					background: ${props.outerBgColor || "transparent"};
					padding-top: ${paddingStyles.top}em;
					padding-bottom: ${paddingStyles.bottom}em;
				}

				@media (max-width: 767.98px) {
					.outerWrapper {
						padding-top: ${paddingStyles.topMobile}em;
						padding-bottom: ${paddingStyles.bottomMobile}em;
					}
				}

				.innerWrapper {
					background: ${props.innerBgColor || "transparent"};
				}

				.leftSide {
					align-self: normal;
					display: flex;
					align-items: center;
					justify-content: center;
					background: ${leftBgColor};
				}

				.rightSide {
					align-self: normal;
					display: flex;
					align-items: center;
					justify-content: center;
					background: ${rightBgColor};
				}
			`}</style>
		</div>
	);
}
